<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ title }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <template v-if="showInformuojamasPastaba">
              <v-alert class="mt-5" type="info" outlined color="#e4800d">
                {{ informuojamasPastaba }}
              </v-alert>
            </template>
            <template v-if="checkingStatus">
              <v-alert class="mt-5" type="info" outlined color="green">
                Formuojamas pranešimas
              </v-alert>
            </template>
            <template v-if="!checkingStatus">
              <v-row>
                <v-col cols="12" v-if="showNaujasAdresatas">
                  <el-switch
                    label="Naujas adresatas"
                    :tooltip="naujasAdresatasTooltip"
                    v-model="newItem"
                    :readonly="newItemReadonly"
                    @click.native="setNewItem()"
                  />
                </v-col>
                <v-col cols="12">
                  <el-text-field
                    required
                    :readonly="readonlyAdresatas"
                    label="Adresatas"
                    :tooltip="adresatasTooltip"
                    v-model="item.asm_pavadinimas"
                    :autofocus="!readonlyAdresatas"
                  />
                </v-col>
                <v-col cols="12" class="pt-3">
                  <div
                    class="pastas"
                    v-for="(pastas, index) in item.sasm_el_pastai"
                    :key="index"
                  >
                    <el-pastas
                      class="my-0 py-0"
                      :required="requiredPastas"
                      :label="`${index === 0 ? 'Adresato el. paštas' : ''}`"
                      :tooltip="`${index === 0 ? adresatasPastasTooltip : ''}`"
                      :validate-key="`${item.sasm_id}-${index}`"
                      :hide-details="true"
                      v-model="item.sasm_el_pastai[index]"
                      :autofocus="readonlyAdresatas"
                      :readonly="readonlyPastas"
                    />
                    <el-table-action
                      v-if="!readonlyPastas"
                      class="mt-0"
                      :item="{ canDelete: item.sasm_el_pastai.length > 1 }"
                      @deleteItem="deleteItem(item, index)"
                    />
                  </div>
                  <el-button
                    v-if="!readonlyPastas"
                    class="mt-2"
                    x-small
                    @click.native="addItem(item)"
                  >
                    Pridėti el. paštą
                  </el-button>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button :loading="loadingCancel" @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button
          :loading="loading"
          primary
          @click.native.stop="testi()"
          v-if="!readonlyTesti"
        >
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'

export default {
  name: 'ModalInformavimas',
  props: {
    value: Boolean,
    item: Object,
    resend: { type: Boolean, default: false },
    readonly: Boolean,
    rusis: String,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      loadingCancel: false,
      tableLoading: false,
      newItem: false,
      newItemReadonly: false,
      checkingStatus: false,
      pranesimasStatusID: null,
      refreshTimer: null,
      refreshTimeout: 3000,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    title() {
      return this.resend
        ? 'Pakartotinas pranešimo siuntimas'
        : 'Informuojamas asmuo'
    },
    naujasAdresatasTooltip() {
      return 'Modalas Informavimas. Naujas adresatas'
    },
    adresatasTooltip() {
      return this.resend
        ? 'Modalas Informavimas. Adresatas. Pakartotinas'
        : 'Modalas Informavimas. Adresatas'
    },
    adresatasPastasTooltip() {
      return this.resend
        ? 'Modalas Informavimas.Adresato el. paštas. Pakartotinas'
        : 'Modalas Informavimas. Adresato el. paštas'
    },
    readonlyAdresatas() {
      return (
        this.item &&
        (!!this.item.amn_id ||
          this.item.can_delete === false ||
          (this.resend && !this.newItem))
      )
    },
    readonlyPastas() {
      return this.readonly && !this.resend
    },
    requiredPastas() {
      return !this.item.amn_id
    },
    readonlyTesti() {
      return this.readonly && !this.resend
    },
    showNaujasAdresatas() {
      return (
        this.resend &&
        this.rusis &&
        !this.rusis.includes('siunciami-atmetimas') &&
        !this.rusis.includes('siunciami-grazinimas')
      )
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isInformuojamas() {
      return (
        !this.item.sasm_role_objekte ||
        this.item.sasm_role_objekte === 'informuojamas'
      )
    },
    showInformuojamasPastaba() {
      return !this.readonly && !this.resend && this.isInformuojamas
    },
    informuojamasPastaba() {
      if (this.isSutartis) {
        return 'Į adresatus įtrauktas informuojamas asmuo bus informuotas tik bendruoju pranešimu el. laiške. Prisijungti prie sistemos ir pažiūrėti pranešimo rinkmenos negalės, nes jis nėra sutarties šalis'
      }
      return 'Į adresatus įtrauktas informuojamas asmuo bus informuotas tik bendruoju pranešimu el. laiške. Prisijungti prie sistemos ir pažiūrėti pranešimo rinkmenos negalės, nes jis nėra hipotekos / įkeitimo šalis'
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.newItem = false
        this.newItemReadonly = false
      }
    },
  },
  created() {},
  methods: {
    testi() {
      if (this.resend) {
        this.resendData()
      } else {
        this.saveData()
      }
    },
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          this.loadingCancel = true

          let data = {
            obj_id: this.objektasID,
            sasm_id: this.item.sasm_id,
            asm_pavadinimas: this.item.asm_pavadinimas,
            sasm_el_pastai: this.item.sasm_el_pastai,
          }
          this.$axios
            .post(`asmuo/informuojamas`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.$emit('confirmSave')
              this.closeModal()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
              this.loadingCancel = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    resendData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          this.loadingCancel = true
          const data = {
            zus_id: this.item.zus_id,
            zus_adresatas: this.item.asm_pavadinimas,
            zus_adresato_el_pastai: this.item.sasm_el_pastai,
          }

          this.$axios
            .post(
              `objektas/${this.objektasID}/issiustipranesimai/${this.item.zus_id}/resend`,
              data
            )
            .then(res => {
              this.checkingStatus = true
              this.pranesimasStatusID = res.data.zus_id
              // window._VMA.$emit('DATA_OK', res.data.message)
              // this.$emit('confirmResend')
              // this.closeModal()
              this.startStatus()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              // this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    getStatus() {
      this.loadingCancel = false
      this.$axios
        .get(
          `objektas/${this.objektasID}/issiustipranesimai/${this.pranesimasStatusID}/statusas`
        )
        .then(res => {
          if (res.data.suformuotas) {
            window._VMA.$emit('DATA_OK', 'Pranešimas išsiųstas')
            this.$emit('confirmResend')
            this.stopStatus()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    startStatus() {
      if (this.checkingStatus) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            this.getStatus()
          }, this.refreshTimeout)
        }
      } else {
        this.stopStatus()
      }
    },
    stopStatus() {
      this.closeModal()
    },
    setNewItem() {
      this.newItemReadonly = true
      this.item.asm_pavadinimas = null
      this.item.sasm_el_pastai = ['']
      this.$validator.reset()
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
      this.loading = false
      this.loadingCancel = false
      this.checkingStatus = false
      this.showModal = false
    },
    modalshow() {
      //
    },
    submit() {
      this.testi()
    },
    cancel() {
      this.cancelData()
    },
    addItem(item) {
      item.sasm_el_pastai.push('')
    },
    deleteItem(item, index) {
      item.sasm_el_pastai.splice(index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.pastas {
  width: 100%;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  line-height: 40px;
}
</style>
